<template>
  <div id="app">
    <Header />
    <transition>
      <router-view></router-view>
    </transition>
    <LoginModal v-if="!displayLogin()" ref="loginModal" />
    <Footer />
  </div>
</template>
<script>
import LoginModal from "@/layout/LoginModal.vue";
import Footer from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
import UserStore from "@/store/userStore";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    LoginModal
  },
  watch: {
    $route() {
      setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, 300);
      this.setPageTitle();
    }
  },
  created() {
    UserStore.commit("initialiseStore");
  },
  mounted() {
    this.fetchRecipes();
  },
  methods: {
    decodeHTML(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    async setPageTitle() {
      let body = await fetch(window.location.href);
      body = await body.text();
      const title = body.split("<title>")[1].split("</title>")[0];
      document.title = this.decodeHTML(title);
    },
    displayLogin() {
      return (
        !["register", "login"].includes(this.$route.name) &&
        UserStore.state.logged
      );
    },
    async fetchRecipes() {
      this.$store.state.recipes = await this.getApi("allrecipes");
      this.$store.state.categories = await this.getApi("categories");
    }
  }
};
</script>

<style lang="scss">
@import "scss/styles.scss";
#app {
  overflow: hidden;
  min-height: 100.1vh;
}
</style>
